{
  "languages": ["fr", "en", "es", "it", "de", "pt", "nl", "pl", "ro"],
  "pages": [
    {
      "path": "",
      "changefreq": "weekly",
      "priority": "1.0"
    },
    {
      "path": "home2",
      "indexable": false
    },
    {
      "path": "vps-standard",
      "changefreq": "weekly",
      "priority": "0.9"
    },
    {
      "path": "vps-performance",
      "changefreq": "weekly",
      "priority": "0.9"
    },
    {
      "path": "plesk",
      "changefreq": "weekly",
      "priority": "0.9"
    },
    {
      "path": "plesk-dedicated",
      "changefreq": "weekly",
      "priority": "0.8"
    },
    {
      "path": "domains",
      "changefreq": "weekly",
      "priority": "0.9"
    },
    {
      "path": "datacenter",
      "changefreq": "monthly",
      "priority": "0.8"
    },
    {
      "path": "ip-tunnels",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "antiddos",
      "changefreq": "monthly",
      "priority": "0.8"
    },
    {
      "path": "workspace",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "dedicated",
      "changefreq": "monthly",
      "priority": "0.8"
    },
    {
      "path": "ssl",
      "changefreq": "monthly",
      "priority": "0.6"
    },
    {
      "path": "fibre",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "telephonie",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "status",
      "changefreq": "daily",
      "priority": "0.6"
    },
    {
      "path": "contact",
      "changefreq": "yearly",
      "priority": "0.5"
    },
    {
      "path": "about",
      "changefreq": "yearly",
      "priority": "0.5"
    },
    {
      "path": "guide-vps",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "guide-plesk",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "guide-antiddos",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "guide-colocation",
      "changefreq": "monthly",
      "priority": "0.7"
    },
    {
      "path": "mentions-legales",
      "changefreq": "yearly",
      "priority": "0.3",
      "languages": ["fr"]
    },
    {
      "path": "confidentialite",
      "changefreq": "yearly",
      "priority": "0.3",
      "languages": ["fr"]
    },
    {
      "path": "cgu",
      "changefreq": "yearly",
      "priority": "0.3",
      "languages": ["fr"]
    },
    {
      "path": "api",
      "indexable": false,
      "languages": ["fr"]
    }
  ],
  "aliases": {
    "vps-intel": "vps-standard",
    "vps-ryzen": "vps-performance",
    "home3": ""
  }
}
